import { createLogger } from '../../../../../shared/helpers/loggerFacade';

export const logger = createLogger('goloom:waiting-rooms');
